export default __webpack_public_path__ + "a3ce49f57632d6e2daf2fefde35c2bea.png";